document.addEventListener("DOMContentLoaded", function () {

  function addDiscountToCartShare(url) {

    if (!url.includes("/apps/cartshare/view")) {
      return url;
    }


    let discount = localStorage.getItem("cart_discounts");


    if (!discount) {
      return url;
    }


    let codes = JSON.parse(discount);


    if (!codes.length) {
      return url;
    }


    let cartShareURL = new URL(url);

    let token = cartShareURL.searchParams.get("token");


    if (!token) {
      return url;
    }


    // Start with CartShare URL
    let redirectURL =
      "/apps/cartshare/view?token=" + token;


    // Add discounts backwards
    for (let i = codes.length - 1; i >= 0; i--) {

      redirectURL =
        "/discount/" +
        codes[i] +
        "?redirect=" +
        redirectURL;

    }


    let newURL =
      window.location.origin + redirectURL;


    console.log(
      "Updated ShareCart:",
      newURL
    );


    return newURL;

  }



  if (navigator.clipboard) {

    const originalCopy =
      navigator.clipboard.writeText.bind(
        navigator.clipboard
      );


    navigator.clipboard.writeText = function(text){

      return originalCopy(
        addDiscountToCartShare(text)
      );

    };

  }


});